<template>
    <veui-dialog
        :title="title"
        :open.sync="isConfirmDialogShow"
        overlay-class="confirm-dialog"
        :before-close="beforeClose"
        :footless="true"
    >
        {{ content }}
        <div class="foot-button">
            <veui-button
                ui="l strong"
                class="left-btn"
                @click="handleOk"
            >
                {{ leftBtnText }}
            </veui-button>
            <veui-button
                ui="l primary"
                @click="handleCancel"
            >
                {{ rightBtnText }}
            </veui-button>
        </div>
    </veui-dialog>
</template>

<script>
import {Dialog, Button} from 'veui';

export default {
    name: 'confirm-dialog',
    components: {
        'veui-dialog': Dialog,
        'veui-button': Button
    },
    props: {
        title: {
            type: String,
            default: ''
        },
        leftBtnText: {
            type: String,
            default: ''
        },
        rightBtnText: {
            type: String,
            default: ''
        },
        content: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            isConfirmDialogShow: false
        };
    },
    methods: {
        open() {
            this.isConfirmDialogShow = true;
        },
        close() {
            this.isConfirmDialogShow = false;
        },
        handleOk() {
            this.close();
            this.$wywLog.send({
                serverId: 20062,
                area: this.type + '-left-btn',
                action: 'click'
            });
            this.$emit('ok');
        },
        handleCancel() {
            this.close();
            this.$wywLog.send({
                serverId: 20062,
                area: this.type + '-right-btn',
                action: 'click'
            });
            this.$emit('cancel');
        },
        beforeClose(type) {
            // 点击x按钮
            if (type === 'cancel') {
                this.$wywLog.send({
                    serverId: 20062,
                    area: this.type + '-x-btn',
                    action: 'click'
                });
            }
        }
    }
};
</script>

<style lang='less' scoped>
.confirm-dialog {
    ::v-deep .veui-dialog-content {
        width: 355px;
        border-radius: 8px;
    }

    ::v-deep .veui-dialog-content-body {
        font-size: 16px;
        color: #000311;
    }

    .foot-button {
        display: flex;
        justify-content: right;
        margin-top: 18px;

        .veui-button {
            height: 44px;
            padding: 0 36px;
            border-radius: 6px;

            &.left-btn {
                border: 1px solid #1e1f2433 !important;
                color: #1e1f24 !important;
                margin-right: 12px;
            }
        }
    }
}
</style>
